import React from 'react'
import { Bar } from 'react-chartjs-2';

const Masuk = (props) => {
    const debit = props.data;
    return (
        <div className='card'>
            <header className='card-header'>
                <p className='card-header-title is-size-7'>Masuk</p>
            </header>
            <div className='card-content'>
                <Bar
                    data={{
                        labels: debit.map((item) => item.category),
                        datasets: [
                            {
                                label: "Debit (Pemasukan)",
                                data: debit.map((item) => item.amount / 1000),
                                backgroundColor: 'rgba(0,0,255,0.5',
                            }
                        ]
                    }}
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                position: 'bottom',
                            },
                            title: {
                                display: false,
                                text: 'Debit (Pemasukan) x1.000'
                            }
                        },
                        scales: {
                            y: {
                                title: {
                                    display: true,
                                    text: 'Rupiah (Rp.) x 1000'
                                },
                                // min: 0,
                                // max: 10000,
                                beginAtZero: true,
                                ticks: {
                                    // forces step size to be 50 units
                                    //stepSize: 500
                                }
                            }
                        }
                    }}
                    height={300}
                />
            </div>
        </div>
    )
}

export default Masuk
